import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'

type Props = {
  to: string
  replace?: boolean
}

// This helper exists because React Router's Navigate component does not support
// view transitions, so we need to use the imperative navigate function instead.

// This component will navigate to the specified route with a view transition
// when it is mounted.
const ViewTransitionNavigate: React.FC<Props> = ({ to, replace = false }) => {
  const navigate = useNavigate()
  const hasNavigatedRef = useRef(false)

  useEffect(() => {
    if (hasNavigatedRef.current) return
    hasNavigatedRef.current = true
    navigate(to, { replace, viewTransition: true })
  }, [navigate, replace, to])

  return null
}

export default ViewTransitionNavigate
